export enum PaymentMethodEnum {
  Cash = "CASH",
  Credit = "CREDIT",
  Cheque = "CHEQUE",
  Hybrid = "HYBRID",
}
